import React, { useContext, useMemo } from 'react'
import { MenuProps } from '@mui/material/Menu'
import { PopupState } from 'material-ui-popup-state/core'
import HoverMenu from 'material-ui-popup-state/HoverMenu'
import { bindMenu } from 'material-ui-popup-state/hooks'

import { CascadingContext } from './index'

interface ICascadingMenu extends Partial<MenuProps> {
  popupState: PopupState
}

const CascadingMenu = ({ popupState, ...props }: ICascadingMenu) => {
  const { rootPopupState } = useContext(CascadingContext)
  const context = useMemo(
    () => ({
      rootPopupState: rootPopupState || popupState,
      parentPopupState: popupState,
    }),
    [rootPopupState, popupState]
  )

  return (
    <CascadingContext.Provider value={context}>
      <HoverMenu {...props} {...bindMenu(popupState)} />
    </CascadingContext.Provider>
  )
}

export default CascadingMenu
